<template>
  <modal
    :show="studyTask && show"
    @close="$emit('closed')"
    height="auto"
    :accept-text="studyTask.ModalButtonText"
    accept-classes="primary"
    :hide-left-button="true"
  >
    <h5 class="center-text sub-header">{{ studyTask.ModalHeader }}</h5>
    <div v-html="toHtml(studyTask.ModalText)"></div>
  </modal>
</template>

<script>
import StudyTaskModel from '@/Models/StudyTaskModel';
import { toHtml } from '@/Helpers/markdown';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    studyTask: {
      type: StudyTaskModel,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    toHtml
  }
};
</script>

<style></style>
